import { Component } from '@angular/core';

@Component({
  selector: 'app-admin-conformidades',
  imports: [],
  templateUrl: './admin-conformidades.component.html',
  styleUrl: './admin-conformidades.component.css'
})
export class AdminConformidadesComponent {

}
